import { render, staticRenderFns } from "./vggrid.vue?vue&type=template&id=577b0a38&scoped=true&"
import script from "./vggrid.vue?vue&type=script&lang=js&"
export * from "./vggrid.vue?vue&type=script&lang=js&"
import style0 from "./vggrid.vue?vue&type=style&index=0&id=577b0a38&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "577b0a38",
  null
  
)

export default component.exports